module.exports = __webpack_public_path__ + "static/media/dropdown-focus.b6e8eb20.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/dropdown-focus.svg
// module id = 1907
// module chunks = 68